(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@meteor/frontend-effimate-main"] = factory();
	else
		root["@meteor/frontend-effimate-main"] = factory();
})(self, () => {
return 